import{useEffect,useMemo,useState}from"react";
import{authApi,type WorkspaceAccess}from"../lib/authApi";
import{LanguageSwitcher,useAppI18n,type I18nKey}from"../lib/appI18n";

const securityLinks:[I18nKey,string][]=[
 ["nav.overview","/security"],
 ["nav.users","/security?section=users"],
 ["nav.registrations","/security?section=registrations"],
 ["nav.identityAccess","/security?section=access"],
 ["nav.requests","/security?section=requests"],
 ["nav.devices","/security?section=devices"],
 ["nav.sessions","/security?section=sessions"],
 ["nav.vaults","/security?section=vaults"],
 ["nav.recovery","/security?section=recovery"],
 ["nav.audit","/security?section=audit"],
 ["nav.policies","/security?section=policies"],
 ["nav.settings","/security?section=settings"],
];

export function GlobalFooter(){
 const{t}=useAppI18n();
 const[workspaces,setWorkspaces]=useState<WorkspaceAccess[]>([]);

 useEffect(()=>{
  let cancelled=false;
  void authApi.me()
   .then(me=>{if(!cancelled)setWorkspaces(me.authorization?.workspaces??[]);})
   .catch(()=>{});
  return()=>{cancelled=true;};
 },[]);

 const keys=useMemo(()=>new Set(workspaces.map(row=>row.key)),[workspaces]);
 const hasSecurity=keys.size===0||keys.has("SECURITY_CENTER");
 const hasAgent=keys.has("AGENT_CONTROL");
 const other=workspaces.filter(row=>!["SECURITY_CENTER","AGENT_CONTROL"].includes(row.key));

 return(
  <footer className="v2-global-footer">
   <div className="v2-footer-intro">
    <span className="eyebrow">KNSAIX</span>
    <strong>{t("footer.explore")}</strong>
    <button
     type="button"
     className="v2-footer-search"
     onClick={()=>window.dispatchEvent(new Event("knsaix:global-search"))}
    >
     ⌕ {t("footer.search")}
    </button>
   </div>

   {hasSecurity?
    <details className="v2-footer-group" open>
     <summary>{t("footer.security")}</summary>
     <nav aria-label={t("footer.security")}>
      {securityLinks.map(([key,href])=><a key={href} href={href}>{t(key)}</a>)}
     </nav>
    </details>
   :null}

   <details className="v2-footer-group" open>
    <summary>{t("footer.operations")}</summary>
    <nav aria-label={t("footer.operations")}>
     {hasAgent?<a href="/operations/agent-control">{t("nav.agentControl")}</a>:null}
     {hasSecurity?<a href="/operations/provider-market">{t("nav.providerMarket")}</a>:null}
     {!hasAgent&&!hasSecurity?<span>—</span>:null}
    </nav>
   </details>

   {other.length?
    <details className="v2-footer-group">
     <summary>{t("footer.workspaces")}</summary>
     <nav aria-label={t("footer.workspaces")}>
      {other.map(row=><a key={row.key} href={row.route}>{row.display_name}</a>)}
     </nav>
    </details>
   :null}

   <div className="v2-footer-utility">
    <a href="/">{t("footer.home")}</a>
    <button type="button" onClick={()=>window.scrollTo({top:0,behavior:"smooth"})}>
     ↑ {t("footer.backTop")}
    </button>
    <LanguageSwitcher/>
   </div>
  </footer>
 );
}
